<mat-toolbar class="flex items-center header">
    <div class="w-full">

        <div class="w-full h-full flex flex-row items-center gap-2 ">
            <button [routerLink]="'/sessions'"><img alt="Mass Eligibility" class="logo clickable" src="/assets/logo_no_text.png"></button>
            <div class="flex flex-col gap-2">
                <div class="flex flex-row items-center gap-2">
                    <span class="session-name">{{session()?.name}}</span><small> #{{session()?.code}}</small>
                    <button matIconButton matTooltip="Modifier le nom de la session" (click)="editSessionNameClicked.emit()"><mat-icon>edit</mat-icon></button>
                    <button matIconButton matTooltip="Dupliquer cette session" (click)="duplicateSessionClicked.emit()"><mat-icon>content_copy</mat-icon></button>
                    <button matIconButton matTooltip="Partager cette session" [cdkCopyToClipboard]="currentUrl()" (click)="shareSessionClicked.emit()"><mat-icon>share</mat-icon></button>
                </div>
                
                <div class="flex flex-row w-full items-center gap-2">
                    <mat-button-toggle-group [(ngModel)]="displayMode" class="input-mode-select">
                        @for (option of DISPLAY_MODE_OPTIONS; track option) {
                            <mat-button-toggle [value]="option.value">{{option.name}}</mat-button-toggle>
                        }
                    </mat-button-toggle-group>

                    @if (displayMode() === 'addressValidation') {
                        <button [matMenuTriggerFor]="importMenu" mat-stroked-button><mat-icon>upload</mat-icon> Importer</button>
                        <mat-menu #importMenu="matMenu">
                            <button mat-menu-item (click)="importSitesManuallyClicked.emit()">Saisie manuelle</button>
                            <button mat-menu-item (click)="importSitesFromClientClicked.emit()">Depuis un client existant</button>
                            <button mat-menu-item (click)="importSitesFromFileClicked.emit()">Depuis un fichier CSV / XLSX</button>
                        </mat-menu>
                        
                        <button [matMenuTriggerFor]="exportMenu" mat-stroked-button>
                            <mat-icon>download</mat-icon> Exporter ({{toBeExportedSitesLength()}} site{{toBeExportedSitesLength() > 1 ? 's' : ''}})
                        </button>
                    
                        <mat-menu #exportMenu="matMenu">
                            <button mat-menu-item (click)="exportStdXlsxClicked.emit()">Format Excel standard</button>
                            <button mat-menu-item (click)="exportNova2CsvClicked.emit()">Format NOVA2 .CSV</button>
                            <button mat-menu-item (click)="exportNova2XlsxClicked.emit()">Format NOVA2 .XLSX</button>
                        </mat-menu>
            
                        <button mat-stroked-button [disabled]="selectedSitesLength() === 0" (click)="relaunchAddressValidation.emit()">
                            <mat-icon>replay</mat-icon> Relancer la fiabilisation ({{selectedSitesLength()}} site{{selectedSitesLength() > 1 ? 's' : ''}})
                        </button>
                        <button mat-stroked-button [disabled]="selectedSitesLength() === 0" (click)="deleteSitesClicked.emit()">
                            <mat-icon>delete</mat-icon> Supprimer ({{selectedSitesLength()}} site{{selectedSitesLength() > 1 ? 's' : ''}})
                        </button>
                    } @else {
                        <button [matMenuTriggerFor]="exportMenu" mat-stroked-button>
                            <mat-icon>download</mat-icon> Exporter ({{toBeExportedSitesLength()}} site{{toBeExportedSitesLength() > 1 ? 's' : ''}})
                        </button>
                    
                        <mat-menu #exportMenu="matMenu">
                            <button mat-menu-item (click)="exportStdXlsxClicked.emit()">Format Excel standard</button>
                            <button mat-menu-item (click)="exportNova2CsvClicked.emit()">Format NOVA2 .CSV</button>
                            <button mat-menu-item (click)="exportNova2XlsxClicked.emit()">Format NOVA2 .XLSX</button>
                        </mat-menu>
                        
                        <button class="button-size" [disabled]="eligibilitySelectedSitesLength() === 0" (click)="openEligibilityModalClicked.emit()" mat-stroked-button>
                            <mat-icon>network_check</mat-icon> Lancer l'éligibilité ({{eligibilitySelectedSitesLength()}} site{{eligibilitySelectedSitesLength() > 1 ? 's' : ''}})
                        </button> 
                        @if (COMMERCIAL_ELIGIBILITY_ENABLED) {
                            <button class="button-size" (click)="openAccessConfigurationClicked.emit()" mat-stroked-button>Configurer accès</button>
                        }
                    }
                </div>
            </div>

            <div class="spacer"></div>
            
            <button class="mr-2" mat-icon-button matTooltip="FAQ" (click)="openHelp()">
                <mat-icon>help</mat-icon>
            </button>
        </div>
    </div>

</mat-toolbar>